import React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { translate } from 'utils/translateUtils';

import visaLogo from './static/img/visa.svg';
import mastercardLogo from './static/img/mastercard.svg';

import './index.scss';

const enhance = compose(translate);

const b = b_.with('footer-page-info');

class FooterInfo extends React.Component {
  render() {
    const { t, lng } = this.props;

    const lang = lng.toLowerCase();

    const policyLink = `https://investment-s3.unitedtraders.io/files/privacy-policy_${lang}.pdf`;

    const riskStatementsLink =
      'https://investment-s3.unitedtraders.io/files/Risk_Statement_UT_Overseas_170918.pdf';

    return (
      <div className={b()}>
        <div className={b('logos')}>
          <img src={visaLogo} alt="Visa" />
          <img src={mastercardLogo} alt="Mastercard" />
        </div>
        <div className={b('links')}>
          <a href={riskStatementsLink} target="_blank" rel="noopener" className={b('link')}>
            {t('Risk statements')}
          </a>
          <a className={b('link')} target="_blank" rel="noopener" href={policyLink}>
            {t('Privacy policy')}
          </a>
        </div>
      </div>
    );
  }
}

export default enhance(FooterInfo);



// WEBPACK FOOTER //
// ./src/blocks/footer/components/Info/index.js